function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, MenuItem, Select, FormControl, InputLabel, Chip, Alert, Stack, CircularProgress } from '@mui/material';
import { Add as AddIcon, ListAltOutlined as EditIcon, DeleteOutlined as DeleteIcon, FilterListOutlined as FilterIcon } from '@mui/icons-material';
import RoleModal from '../components/RoleModal';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
var RoleManagement = function RoleManagement() {
    var _applications$find;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), roles = _useState2[0], setRoles = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), applications = _useState4[0], setApplications = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), policies = _useState6[0], setPolicies = _useState6[1];
    var _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), selectedApplication = _useState8[0], setSelectedApplication = _useState8[1];
    var _useState9 = useState(true), _useState0 = _slicedToArray(_useState9, 2), dataLoading = _useState0[0], setDataLoading = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), error = _useState10[0], setError = _useState10[1];
    // Modal and dialog state
    var _useState11 = useState(false), _useState12 = _slicedToArray(_useState11, 2), roleModalOpen = _useState12[0], setRoleModalOpen = _useState12[1];
    var _useState13 = useState(null), _useState14 = _slicedToArray(_useState13, 2), selectedRole = _useState14[0], setSelectedRole = _useState14[1];
    var _useState15 = useState(false), _useState16 = _slicedToArray(_useState15, 2), deleteDialogOpen = _useState16[0], setDeleteDialogOpen = _useState16[1];
    var _useState17 = useState(null), _useState18 = _slicedToArray(_useState17, 2), roleToDelete = _useState18[0], setRoleToDelete = _useState18[1];
    var _useState19 = useState(false), _useState20 = _slicedToArray(_useState19, 2), loading = _useState20[0], setLoading = _useState20[1];
    var _useState21 = useState(''), _useState22 = _slicedToArray(_useState21, 2), successMessage = _useState22[0], setSuccessMessage = _useState22[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var _yield$Promise$all, _yield$Promise$all2, rolesWithDataResponse, applicationsResponse, policiesResponse, transformedRoles, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setDataLoading(true);
                            setError(null);
                            _context.p = 1;
                            _context.n = 2;
                            return Promise.all([UserAPI.getRolesWithPoliciesAndCounts(), UserAPI.getApplications(), UserAPI.getPolicies()]);
                        case 2:
                            _yield$Promise$all = _context.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                            rolesWithDataResponse = _yield$Promise$all2[0];
                            applicationsResponse = _yield$Promise$all2[1];
                            policiesResponse = _yield$Promise$all2[2];
                            // Transform the aggregated role data to match the existing format
                            transformedRoles = rolesWithDataResponse.resource.map(function (role) {
                                return {
                                    id: role.role_id,
                                    name: role.role_name,
                                    application_id: role.application_id,
                                    organization_id: role.organization_id,
                                    role_key: role.role_key,
                                    policies: role.policies.map(function (policy) {
                                        return policy.policy_name;
                                    }),
                                    // Extract policy names
                                    peopleAssigned: role.assignment_count,
                                    dateAdded: role.metadata && role.metadata.createdDate ? new Date(role.metadata.createdDate).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }) : 'Unknown'
                                };
                            });
                            setRoles(transformedRoles);
                            setApplications(applicationsResponse.resource);
                            setPolicies(policiesResponse.resource);
                            // Set default application filter to first application if available
                            if (applicationsResponse.resource.length > 0) {
                                setSelectedApplication(applicationsResponse.resource[0].name);
                            }
                            // No need to load policies and counts separately anymore as they come with the aggregated data
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Failed to load data:', _t);
                            setError('Failed to load roles, applications, and policies. Please try again.');
                            setRoles([]);
                        case 4:
                            _context.p = 4;
                            setDataLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddRole = function handleAddRole() {
        if (!selectedApplication) {
            setError('Please select an application before creating a role.');
            return;
        }
        setSelectedRole(null);
        setRoleModalOpen(true);
    };
    var handleEditRole = function handleEditRole(role) {
        setSelectedRole(role);
        setRoleModalOpen(true);
    };
    var handleDeleteRole = function handleDeleteRole(role) {
        setRoleToDelete(role);
        setDeleteDialogOpen(true);
    };
    var handleSaveRole = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(roleData) {
            var updateRequest, currentPoliciesResponse, currentPolicyNames, policiesToAdd, policiesToRemove, policyIdsToAdd, policyIdsToRemove, selectedApp, createRequest, response, newRole, selectedPolicyIds, _t2, _t3, _t4;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context2.p = 1;
                            if (!selectedRole) {
                                _context2.n = 11;
                                break;
                            }
                            if (!(!selectedRole.application_id || !selectedRole.role_key || !selectedRole.organization_id)) {
                                _context2.n = 2;
                                break;
                            }
                            setError('Missing required role information. Unable to update role.');
                            return _context2.a(2);
                        case 2:
                            updateRequest = {
                                organization_id: parseInt(selectedRole.organization_id),
                                application_id: selectedRole.application_id,
                                role_name: roleData.name,
                                role_key: roleData.name.toLowerCase().replace(/\s+/g, '_') // Generate new role_key if name changed
                            };
                            _context2.n = 3;
                            return UserAPI.updateRole(selectedRole.id, updateRequest);
                        case 3:
                            if (!(roleData.policies !== undefined && selectedRole.id)) {
                                _context2.n = 9;
                                break;
                            }
                            _context2.p = 4;
                            _context2.n = 5;
                            return UserAPI.getRolePolicies(selectedRole.id);
                        case 5:
                            currentPoliciesResponse = _context2.v;
                            currentPolicyNames = currentPoliciesResponse.resource.map(function (p) {
                                return p.name;
                            }); // Find new policies to add
                            policiesToAdd = roleData.policies.filter(function (p) {
                                return !currentPolicyNames.includes(p);
                            }); // Find policies to remove (current policies not in the new selection)
                            policiesToRemove = currentPolicyNames.filter(function (p) {
                                return !roleData.policies.includes(p);
                            }); // Add new policies
                            if (!(policiesToAdd.length > 0)) {
                                _context2.n = 6;
                                break;
                            }
                            policyIdsToAdd = policiesToAdd.map(function (policyName) {
                                var _policies$find;
                                return (_policies$find = policies.find(function (p) {
                                    return p.name === policyName;
                                })) === null || _policies$find === void 0 ? void 0 : _policies$find.id;
                            }).filter(function (id) {
                                return id !== undefined;
                            });
                            if (!(policyIdsToAdd.length > 0)) {
                                _context2.n = 6;
                                break;
                            }
                            _context2.n = 6;
                            return UserAPI.createRolePolicy({
                                role_id: parseInt(selectedRole.id),
                                policy_id: policyIdsToAdd
                            });
                        case 6:
                            if (!(policiesToRemove.length > 0)) {
                                _context2.n = 7;
                                break;
                            }
                            policyIdsToRemove = policiesToRemove.map(function (policyName) {
                                var _policies$find2;
                                return (_policies$find2 = policies.find(function (p) {
                                    return p.name === policyName;
                                })) === null || _policies$find2 === void 0 ? void 0 : _policies$find2.id;
                            }).filter(function (id) {
                                return id !== undefined;
                            });
                            if (!(policyIdsToRemove.length > 0)) {
                                _context2.n = 7;
                                break;
                            }
                            _context2.n = 7;
                            return UserAPI.removeSpecificPoliciesFromRole(selectedRole.id, policyIdsToRemove);
                        case 7:
                            _context2.n = 9;
                            break;
                        case 8:
                            _context2.p = 8;
                            _t2 = _context2.v;
                            console.warn('Failed to update policies for role:', _t2);
                        // Don't fail the role update if policy assignment fails
                        case 9:
                            _context2.n = 10;
                            return loadInitialData();
                        case 10:
                            setSuccessMessage('Role updated successfully');
                            _context2.n = 19;
                            break;
                        case 11:
                            // Add new role - get application_id from selected application
                            selectedApp = applications.find(function (app) {
                                return app.name === selectedApplication;
                            });
                            if (selectedApp) {
                                _context2.n = 12;
                                break;
                            }
                            setError('Please select an application before creating a role.');
                            return _context2.a(2);
                        case 12:
                            createRequest = {
                                organization_id: selectedApp.organization_id,
                                application_id: [selectedApp.id.toString()],
                                role_name: roleData.name,
                                role_key: roleData.name.toLowerCase().replace(/\s+/g, '_')
                            };
                            _context2.n = 13;
                            return UserAPI.createRole(createRequest);
                        case 13:
                            response = _context2.v;
                            newRole = {
                                id: response.role_id || Date.now().toString(),
                                name: response.role_name || roleData.name,
                                application_id: response.application_id || selectedApp.id.toString(),
                                role_key: response.role_key || roleData.name.toLowerCase().replace(/\s+/g, '_'),
                                policies: [],
                                peopleAssigned: 0,
                                dateAdded: new Date().toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: 'numeric',
                                    year: 'numeric'
                                })
                            }; // Assign selected policies to the new role
                            if (!(roleData.policies && roleData.policies.length > 0 && newRole.id)) {
                                _context2.n = 18;
                                break;
                            }
                            _context2.p = 14;
                            // Find policy IDs from policy names
                            selectedPolicyIds = roleData.policies.map(function (policyName) {
                                var _policies$find3;
                                return (_policies$find3 = policies.find(function (p) {
                                    return p.name === policyName;
                                })) === null || _policies$find3 === void 0 ? void 0 : _policies$find3.id;
                            }).filter(function (id) {
                                return id !== undefined;
                            });
                            if (!(selectedPolicyIds.length > 0)) {
                                _context2.n = 16;
                                break;
                            }
                            _context2.n = 15;
                            return UserAPI.createRolePolicy({
                                role_id: parseInt(newRole.id),
                                policy_id: selectedPolicyIds
                            });
                        case 15:
                            // Update the role with assigned policies
                            newRole.policies = roleData.policies;
                        case 16:
                            _context2.n = 18;
                            break;
                        case 17:
                            _context2.p = 17;
                            _t3 = _context2.v;
                            console.warn('Failed to assign policies to new role:', _t3);
                        // Don't fail the role creation if policy assignment fails
                        case 18:
                            setRoles(function (prevRoles) {
                                return [].concat(_toConsumableArray(prevRoles), [newRole]);
                            });
                            setSuccessMessage('Role added successfully');
                        case 19:
                            setRoleModalOpen(false);
                            setSelectedRole(null);
                            _context2.n = 21;
                            break;
                        case 20:
                            _context2.p = 20;
                            _t4 = _context2.v;
                            console.error('Error saving role:', _t4);
                            setError('Failed to save role. Please try again.');
                        case 21:
                            _context2.p = 21;
                            setLoading(false);
                            return _context2.f(21);
                        case 22:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[14, 17], [4, 8], [1, 20, 21, 22]]);
        }));
        return function handleSaveRole(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    var confirmDeleteRole = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _t5;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (!roleToDelete) {
                                _context3.n = 6;
                                break;
                            }
                            setLoading(true);
                            setError(null);
                            _context3.p = 1;
                            _context3.n = 2;
                            return UserAPI.deleteAllRolePolicies(roleToDelete.id);
                        case 2:
                            _context3.n = 3;
                            return UserAPI.deleteRole(roleToDelete.id);
                        case 3:
                            setRoles(function (prevRoles) {
                                return prevRoles.filter(function (r) {
                                    return r.id !== roleToDelete.id;
                                });
                            });
                            setSuccessMessage('Role deleted successfully');
                            setDeleteDialogOpen(false);
                            setRoleToDelete(null);
                            _context3.n = 5;
                            break;
                        case 4:
                            _context3.p = 4;
                            _t5 = _context3.v;
                            console.error('Error deleting role:', _t5);
                            setError('Failed to delete role. Please try again.');
                        case 5:
                            _context3.p = 5;
                            setLoading(false);
                            return _context3.f(5);
                        case 6:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[1, 4, 5, 6]]);
        }));
        return function confirmDeleteRole() {
            return _ref3.apply(this, arguments);
        };
    }();
    // Check view permission
    if (!isAuthorized('RBAC:ViewRole')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, "Access Denied"), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, "You don't have permission to view role management settings.")));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8'
        }
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3,
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        sx: {
            mb: 3
        }
    }, "Define roles, view their details, and manage policies."), /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            gap: 2,
            alignItems: 'center'
        }
    }, /*#__PURE__*/ React.createElement(FormControl, {
        size: "small",
        sx: {
            minWidth: 200
        }
    }, /*#__PURE__*/ React.createElement(InputLabel, null, "Application"), /*#__PURE__*/ React.createElement(Select, {
        value: selectedApplication,
        onChange: function onChange(e) {
            return setSelectedApplication(e.target.value);
        },
        label: "Application",
        disabled: dataLoading
    }, applications.map(function (app) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            key: app.id || app.name,
            value: app.name
        }, app.name);
    }))), isAuthorized('RBAC:CreateRole') && /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddRole,
        sx: {
            textTransform: 'none',
            boxShadow: 'none'
        }
    }, "Role"))), dataLoading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, /*#__PURE__*/ React.createElement(CircularProgress, null), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            mt: 2
        }
    }, "Loading roles and applications...")), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 3
        }
    }, error), successMessage && /*#__PURE__*/ React.createElement(Alert, {
        severity: "success",
        sx: {
            mb: 3
        },
        onClose: function onClose() {
            return setSuccessMessage('');
        }
    }, successMessage), !dataLoading && !error && /*#__PURE__*/ React.createElement(TableContainer, null, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '270px'
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Role name"), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Policies assigned")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "# of people assigned")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Date added")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            color: '#212121',
            borderBottom: '1px solid #ebebeb',
            width: '200px'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600
        }
    }, "Actions")))), /*#__PURE__*/ React.createElement(TableBody, null, function () {
        // Filter roles based on selected application
        var filteredRoles = roles.filter(function (role) {
            if (!selectedApplication)
                return true;
            // Find the application by name to get its ID
            var selectedApp = applications.find(function (app) {
                return app.name === selectedApplication;
            });
            if (!selectedApp)
                return false;
            // Check if the role's application_id matches
            return String(role.application_id) === String(selectedApp.id);
        });
        if (filteredRoles.length === 0) {
            return /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
                colSpan: 5,
                sx: {
                    textAlign: 'center',
                    py: 4
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                color: "text.secondary"
            }, "No roles found for the selected application")));
        }
        return filteredRoles.map(function (role) {
            return /*#__PURE__*/ React.createElement(TableRow, {
                key: role.id
            }, /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                sx: {
                    fontWeight: 600,
                    color: '#26890d',
                    textDecoration: 'underline',
                    cursor: isAuthorized('RBAC:UpdateRole') ? 'pointer' : 'default',
                    '&:hover': {
                        color: isAuthorized('RBAC:UpdateRole') ? '#1f6b0a' : '#26890d'
                    }
                },
                onClick: function onClick() {
                    return isAuthorized('RBAC:UpdateRole') && handleEditRole(role);
                }
            }, role.name)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 0.5
                }
            }, role.policies.length > 0 ? role.policies.map(function (policy) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    key: policy,
                    label: policy,
                    size: "small",
                    sx: {
                        backgroundColor: '#f3f8eb',
                        color: '#1a5d09',
                        fontFamily: 'Open Sans',
                        fontSize: 12,
                        fontWeight: 600,
                        height: 20
                    }
                });
            }) : /*#__PURE__*/ React.createElement(Chip, {
                label: "No policies",
                size: "small",
                sx: {
                    backgroundColor: '#ebebeb',
                    color: '#595959',
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: 600,
                    height: 20
                }
            }))), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                color: "#212121"
            }, role.peopleAssigned)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body1",
                color: "#212121"
            }, role.dateAdded)), /*#__PURE__*/ React.createElement(TableCell, {
                sx: {
                    borderBottom: '1px solid #ebebeb',
                    py: 2
                }
            }, /*#__PURE__*/ React.createElement(Box, {
                sx: {
                    display: 'flex',
                    gap: 1
                }
            }, isAuthorized('RBAC:UpdateRole') && /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    return handleEditRole(role);
                },
                sx: {
                    color: '#26890d',
                    '&:hover': {
                        bgcolor: 'rgba(38, 137, 13, 0.04)'
                    }
                }
            }, /*#__PURE__*/ React.createElement(EditIcon, null)), isAuthorized('RBAC:DeleteRole') && /*#__PURE__*/ React.createElement(IconButton, {
                onClick: function onClick() {
                    return handleDeleteRole(role);
                },
                sx: {
                    color: '#da291c',
                    '&:hover': {
                        bgcolor: 'rgba(218, 41, 28, 0.04)'
                    }
                }
            }, /*#__PURE__*/ React.createElement(DeleteIcon, null)))));
        });
    }())))), /*#__PURE__*/ React.createElement(RoleModal, {
        open: roleModalOpen,
        onClose: function onClose() {
            setRoleModalOpen(false);
            setSelectedRole(null);
        },
        onSave: handleSaveRole,
        role: selectedRole,
        loading: loading,
        selectedApplicationId: (_applications$find = applications.find(function (app) {
            return app.name === selectedApplication;
        })) === null || _applications$find === void 0 ? void 0 : _applications$find.id
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: deleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setDeleteDialogOpen(false);
            setRoleToDelete(null);
        },
        submitFunction: confirmDeleteRole,
        title: "Delete Role",
        bodyText: "Are you sure you want to delete the role \"".concat(roleToDelete === null || roleToDelete === void 0 ? void 0 : roleToDelete.name, "\"? This action cannot be undone."),
        submitButtonText: "Delete",
        loading: loading
    }));
};
export default RoleManagement;
